import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { Tooltip } from "radix-ui";
import { RouterProvider } from "react-router";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth-context";
import { ProjetoProvider } from "@/lib/projeto-context";
import { queryClient } from "@/lib/query-client";
import { router } from "@/routes";

/**
 * Composição de providers. A ordem não é arbitrária:
 *
 *   QueryClientProvider  — mais externo, para que um refactor futuro do
 *                          AuthProvider para TanStack Query não obrigue a mexer aqui
 *   ThemeProvider        — tema FIXO em claro desde 14/09 (`forcedTheme`): o
 *                          cliente não quer modo escuro. Fica o provider, e não
 *                          se apaga o CSS `.dark`, para voltar a ser uma linha
 *   Tooltip.Provider     — os componentes shadcn assumem um provider acima
 *   AuthProvider         — sessão, perfil, papéis, permissões
 *   ProjetoProvider      — chama useAuth(), logo tem de estar por dentro
 *   RouterProvider       — por último: ProtectedRoute consome auth E projeto
 *   Toaster              — irmão do router, para os toasts sobreviverem à navegação
 */
export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute="class" defaultTheme="light" forcedTheme="light" enableSystem={false}>
        <Tooltip.Provider delayDuration={200}>
          <AuthProvider>
            <ProjetoProvider>
              <RouterProvider router={router} />
              <Toaster richColors position="top-right" />
            </ProjetoProvider>
          </AuthProvider>
        </Tooltip.Provider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
